export function handleDetectPasskeyMetadata() {
  const origin = typeof window !== "undefined" && window.location ? window.location.origin : "";

  try {
    if (typeof navigator === "undefined") {
      return {
        origin,
        isMobile: false,
        platform: "Unknown",
        browser: "Unknown",
      };
    }

    let browser = "Unknown";
    let platform = "Unknown";
    let isMobile = false;

    if (navigator.userAgentData) {
      const uaData = navigator.userAgentData;
      platform = uaData.platform || "Unknown";
      isMobile = uaData.mobile || false;

      const brandEntries = Array.isArray(uaData.brands)
        ? uaData.brands.filter((b) => b.brand !== "Not)A;Brand")
        : [];
      const lastBrand = brandEntries[brandEntries.length - 1];
      browser = lastBrand ? `${lastBrand.brand} ${lastBrand.version}` : "Unknown";
    } else if (navigator.userAgent) {
      const ua = navigator.userAgent;

      const browserMatchers = [
        { regex: /Chrome\/(\d+)/, name: "Chrome" },
        { regex: /Safari\/(\d+)/, name: "Safari" },
        { regex: /Firefox\/(\d+)/, name: "Firefox" },
        { regex: /Edg\/(\d+)/, name: "Edge" },
      ];

      for (const { regex, name } of browserMatchers) {
        const match = ua.match(regex);
        if (match) {
          browser = `${name} ${match[1]}`;
          break;
        }
      }

      if (/Android/i.test(ua)) {
        platform = "Android";
        isMobile = true;
      } else if (/iPhone|iPad|iPod/i.test(ua)) {
        platform = "iOS";
        isMobile = true;
      } else if (/Mac OS X/i.test(ua)) {
        platform = "macOS";
      } else if (/Windows/i.test(ua)) {
        platform = "Windows";
      }
    }

    return {
      origin,
      isMobile,
      platform,
      browser,
    };
  } catch (error) {
    return {
      origin,
      isMobile: false,
      platform: "Unknown",
      browser: "Unknown",
    };
  }
}